export const ISSUE_ON_BLOCKCHAIN_SUCCESS = 'ISSUE_ON_BLOCKCHAIN_SUCCESS';
export const SET_BLOCKCHAIN_LOADING = 'SET_BLOCKCHAIN_LOADING';
